import React from 'react';
import { BaseComponent } from '../BaseComponent';
import styled from 'styled-components';
import { IsOpen, IsClosed } from '../Icon';

const DropdownContainer = styled.div`
  position: relative;
  width: 100px;
  width: 175px;
`;
const DropdownControl = styled.div`
  position: relative;
`;

const DropdownInput = styled.input`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  height: 45px;
  overflow: hidden;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 2px;
  box-sizing: border-box;
  color: #333;
  cursor: default;
  outline: none;
  padding: 8px 26px 8px 10px;
  transition: all 200ms ease;
`;

const DropdownSelect = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  height: 45px;
  overflow: hidden;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 2px;
  box-sizing: border-box;
  color: #333;
  cursor: default;
  outline: none;
  padding: 8px 10px;
  transition: all 200ms ease;
  @media (max-width: 767.98px) {
    font-size: 16px !important; /* Adjust to your preferred mobile font size */
  }
`;



const IconWrapper = styled.div`
  font-size: 12px;
  position: absolute;
  right: 6px;
  top: 15px;
`;

const DropdownOptions = styled.ul`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: absolute;
  z-index: 12;
  box-sizing: border-box;
  left: 0;
  width: 100%;
  list-style: none;
  border: solid 1px #eee;
  padding: 5px;
  background-color: white;
  max-height: 200px;
  overflow: auto;
  font-size: 12px;
  @media (max-width: 767.98px) {
    font-size: 16px !important; /* Adjust to your preferred mobile font size */
  }
`;

const DropdownOption = styled.li`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? '#0083d5' : 'white')};
  color: ${({ isSelected }) => (isSelected ? 'white' : 'inherited')};

  &:hover {
    background-color: grey;
    color: white;
  }
`;

const STATE = {
  showMenu: false,
};

class MultiselectDropdownComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  get showMenu() {
    return this.props.toggleViewOptions ? this.props.isOpen : this.state.showMenu;
  }

  handleClickOutside = e => {
    e.stopPropagation();
    if (!!this.wrapperRef && !this.wrapperRef?.current?.contains(e.target)) {
      if (this.props.toggleViewOptions) this.props.toggleViewOptions(false);
      this.setState({ showMenu: false });
    }
  };

  toggleMenu = () => {
    // this.props.toggleViewOptions(!this.props.isOpen);
    this.setState(state => ({ showMenu: !state.showMenu }));
  };

  render() {
    const { placeholder, options, selected, toggleOption, search, text, hasSearch } = this.props;
    return (
      <DropdownContainer>
        {hasSearch ? (
          <DropdownControl>
            <DropdownInput value={text} onChange={search} />
            <IconWrapper onClick={this.toggleMenu}>{!this.state.showMenu ? <IsOpen /> : <IsClosed />}</IconWrapper>
          </DropdownControl>
        ) : (
          <DropdownControl>
            <DropdownSelect>{`${placeholder}(${selected?.length ?? 0})`}</DropdownSelect>
            <IconWrapper onClick={this.toggleMenu}>{!this.state.showMenu ? <IsOpen /> : <IsClosed />}</IconWrapper>
          </DropdownControl>
        )}

        <DropdownOptions show={this.state.showMenu} ref={this.wrapperRef}>
          {options?.map((option, idx) => {
            const isSelected = selected?.includes(option?.label?.toLowerCase()) ?? false;
            return (
              <DropdownOption
                isSelected={isSelected}
                key={`ms_${placeholder}_${option?.value}_${idx}`}
                onClick={() => toggleOption(option?.value, option?.label)}
              >
                <span>{option?.label}</span>
              </DropdownOption>
            );
          })}
          {!options?.length && 'No options found'}
        </DropdownOptions>
      </DropdownContainer>
    );
  }
}
export const MultiSelectDropdown = MultiselectDropdownComp;
